import { lazy } from 'react';

export const AffiliateDashboardPageLazy = lazy(
    () => import('./affiliate-dashboard-page'),
);
